import { Injectable } from '@angular/core';
import { FormGroup, FormControl, ValidatorFn } from '@angular/forms';
import { EFormHelper } from '../helper/script/helper';
import { State } from '../model/eform-type';
import { TranslateService } from '@ngx-translate/core';
@Injectable({ providedIn: 'root' })
export class TestValueService {
    eForm: FormGroup;
    state: State;
    helper = new EFormHelper();
    forms: FormGroup;
    errorRegex: boolean;
    constructor(private translate: TranslateService) {
        this.forms = new FormGroup({
            testValue: new FormControl('', [])
        });
        this.errorRegex = false;
    }

    getTestValueForm(eForm: FormGroup, state: State): FormGroup {
        this.eForm = eForm;
        this.state = state;
        this.forms.get('testValue').setValidators([this.customPatternValid({ pattern: '^' + this.regexValues.regex + '$', msg: this.regexValues.msg })]);
        this.forms.get('testValue').updateValueAndValidity();
        return this.forms as FormGroup;
    }

    customPatternValid(config: any): ValidatorFn {
        return (control: FormControl) => {
            const cfgRegEx: RegExp = config.pattern;
            try {
                this.errorRegex = false;
                if (control.value && !control.value.match(cfgRegEx)) {
                    return {
                        invalidMsg: this.regexValues.msg === '' ? this.getMessageTranslations() : config.msg[this.eForm.controls.original.value]
                    };
                } else {
                    return null;
                }
            } catch (e) {
                this.errorRegex = true;
            }
        };
    }

    clearValue(): void {
        this.forms.get('testValue').setValue('');
    }

    get regexValues() {
        const field = this.helper.getFieldAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex) as FormGroup;
        return { isRegex: field.get('isRegex')?.value, regex: field.get('regex')?.value, msg: field.get('regexMessage')?.value };
    }

    getMessageTranslations(): String {
     let _value: String;
     this.translate.get('eform.errors.invalid-input').subscribe(res => _value = res);
     return _value;
   }

}
